import React, { useState } from 'react';
import { tab } from './FaqsAccordion';
import clsx from 'clsx';

export const MktFaqsAccordionTab: React.FC<tab> = ({ description, title }) => {
  const [isExpanded, setIsExpanded] = useState<boolean>(false);

  const expandHandler = () => setIsExpanded(!isExpanded);

  return (
    <div
      className={`whl-flex whl-h-auto whl-cursor-pointer whl-flex-col whl-rounded-sm whl-bg-white-off whl-px-[30px] whl-py-4`}
      onClick={expandHandler}
    >
      <div className="whl-flex whl-items-center whl-justify-between">
        <p className="whl-max-w-[90%] whl-text-[20px] whl-font-medium">
          {title}
        </p>
        <i className={`whl-icon wh-icon-${isExpanded ? 'minus' : 'add'}`} />
      </div>
      <div
        className={clsx(
          'whl-z-[9999] whl-h-0 whl-overflow-hidden whl-text-[20px] whl-transition-all',
          {
            'whl-h-auto whl-pt-[12px]': isExpanded,
          },
        )}
        dangerouslySetInnerHTML={{ __html: description }}
      />
    </div>
  );
};
